<template>
  <v-layout class="flex-column">
    <v-layout wrap fill-height>
      <headband-text
        :title="$t('page.mediaLibrary.title')"
        :overline="$t('page.mediaLibrary.overline')"
      />

      <v-container class="py-10">
        <v-row v-if="!isLoad && documents.length !== 0">
          <v-col
            cols="12" sm="6" md="4" lg="3"
            class="mb-2"
            v-for="(document, fileIndex) in documents"
            :key="fileIndex"
          >
            <document heading="h2" :pump="document"></document>
          </v-col>
        </v-row>
        <v-row v-if="!isLoad && documents.length === 0">
          <v-col
            cols="12" sm="6"
          >
            <v-alert
              icon="mdi-information-outline"
              prominent
              text
              type="info"
              class="mb-0"
            >
              <span v-html="$t('page.mediaLibrary.message.noresult')" />
            </v-alert>
          </v-col>
        </v-row>
      </v-container>
    </v-layout>
    <block-newsletter v-if="!isLoad" />
   </v-layout>
</template>
<script>
import Mixins from '@/core/mixins'
export default {
  name: 'MediaLibrary',
  mixins: [ Mixins ],
  data() {
    return {
      isLoad: true,
      documents: []
    }
  },

  components: {
    HeadbandText: () => import(/* webpackChunkName: "HeadbandText" */ '@/modules/headband/HeadbandText'),
    BlockNewsletter: () => import(/* webpackChunkName: "BlockNewsletter" */ '@/modules/block/BlockNewsletter'),
    Document: () => import(/* webpackChunkName: "Document" */ '@/components/layout/Document'),
  },

  mounted() {
    this.$ga.page('/media-library');
  },

  created () {
    this.handler()
  },

  methods: {
    async handler () {
      const response = await this.request(`/settings/media`)
      this.documents = response
      this.isLoad = false
    },
  }
}
</script>
